"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const react_native_web_lottie_1 = __importDefault(require("react-native-web-lottie"));
const styles_1 = require("../../styles");
const QRScannerLottie = ({ style }) => {
    return (react_1.default.createElement(react_native_1.View, { style: react_native_1.StyleSheet.flatten([styles.lottieView, style]) },
        react_1.default.createElement(react_native_web_lottie_1.default, { source: require('../../../assets/qrScannerLottie.json'), autoPlay: true, loop: true })));
};
exports.default = QRScannerLottie;
const styles = react_native_1.StyleSheet.create({
    lottieView: {
        marginVertical: styles_1.getSpacing(2),
        alignSelf: 'center',
    },
});
